import {Component, computed, input} from '@angular/core';

@Component({
  selector: 'app-hr',
  standalone: true,
  host: {'[class]': 'classes()'},
  template: ''
})
export class Hr {
  type = input<'normal' | 'thick' | 'dashed'>('normal');

  classes = computed(() => {
    const baseClasses = 'block border-default';

    switch(this.type()) {
      case 'thick':
        return `${baseClasses} border-t-2`;
      case 'dashed':
        return `${baseClasses} border-t border-dashed`;
      case 'normal':
      default:
        return `${baseClasses} border-t`;
    }
  });
}
